import axios from 'axios';

export default class AuthService
{
    static AUTH_PATH: string = `${process.env.VUE_APP_REST_PATH}/auth`;
    static USER_PATH: string = `${process.env.VUE_APP_REST_API_PATH}/role/1`;
    static PART_PATH: string = `${process.env.VUE_APP_REST_URI}/participate`;
    static PERM_PATH: string = `${process.env.VUE_APP_REST_PATH}/auth/access`;

    public static async login(email: string, passwd: string)
    {
        let result : UserModel | undefined;

        try
        {
            let response = await axios.post(`${this.AUTH_PATH}/login`,
            {
                username: email,
                password: passwd
            });

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    result = response.data as UserModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return result;
    }

    public static async verify(token: string)
    {
        let result : UserModel | undefined;
        
        interface Permission
        {
            code : string;
        }

        try
        {
            let response = await axios.post(`${this.AUTH_PATH}/verify`,
            {
                token: token,
            });

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    result = response.data as UserModel;
                    localStorage.clear();
                    localStorage.setItem("auth", result.userid.toString());
                    localStorage.setItem("user", (result.firstname + " " + result.lastname));
                    localStorage.setItem("email", result.email);
                    localStorage.setItem("roleid", result.roleid.toString());
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return result;
    }

    public static async getPermissions()
    {
        // first check, if the session is still going
        let ok : bool = await AuthService.isAuthenticated();
        
        // if not, logout the user
        if (!ok)
        {
            AuthService.logout();
            if (this.$router)
            {
                this.$router.push('/login');
            }
            return;
        }

        // interface for permission list
        interface Permission
        {
            code : string;
        };
        
        // clear the session storage
        sessionStorage.clear();
        
        // fetch user permissions
        try
        {
            let response = await axios.get(`${this.AUTH_PATH}/permissions`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    let permissions : Permmission[] = response.data as Permission[];

                    for (let perm of permissions)
                    {
                        sessionStorage.setItem(perm.code, 1);
                    }
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async isAuthenticated() : Promise<boolean>
    {
        try
        {
            let response = await axios.get(`${AuthService.AUTH_PATH}/check`);
            
            if (response && response.status === 200)
            {
                return true;
            }

            return false;
        }
        catch (error)
        {
            return false;
        }
    }

    public static async isCustomer() : Promise<boolean>
    {
        try
        {
            let response = await axios.get(`${AuthService.AUTH_PATH}/permissions/iscustomer`);

            if (response && response.status === 200)
            {
                return response.data as boolean;
            }

            return false;
        }
        catch (error)
        {
            return false;
        }
    }

    public static logout()
    {
        // remove auth flag and user from client storage
        localStorage.clear();
        sessionStorage.clear();
    };

    public static async isLoggedIn() : Promise<boolean>
    {
        // check, if auth is still set in local storage
        let ok : number = localStorage.getItem("auth");
        
        if (!ok) return false;

        if (Number(ok) <= 0) return false;

        return await AuthService.isAuthenticated() as boolean;
    }

    public static hasPermission(permission : string) : Promise<boolean>
    {
        let perm = sessionStorage.getItem(permission);

        if (Number(perm) > 0)
        {
            return true;
        }

        return false;
    }
}
